import { useEffect, useState } from "react";
import api from '../../../services/api.js';
import { pode } from '../../../services/acesso';
import { Container, Table, TableHead, TableBody, TableRow, TableCell, Grid, TextField, Paper, Tooltip } from "@material-ui/core";
import {StyledTableCell,StyledTableRow} from '../../mailing/ListingMailing/styles'
import { toast } from 'react-toastify';
import Pagination from '@material-ui/lab/Pagination';
import { Link, useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";
import EditIcon from '@material-ui/icons/EditOutlined';
import AddIcon from '@material-ui/icons/Add';
import { LinearProgress } from '@material-ui/core';
import InputMask from 'react-input-mask';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import IconButton from '@material-ui/core/IconButton';
import ConfirmDialog from '../../../components/ConfirmDialog';
import PageHeader from '../../../components/PageHeader';
import FilterBar from '../../../components/FilterBar';
import { baixarArquivo } from '../../../services/download';

const POR_PAGINA = 25;

const formatarCnpj = (valor) => {
    const d = String(valor || "").replace(/\D/g, "");
    if (d.length !== 14) return valor || "";
    return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
};

export default () => {
    const history = useHistory();
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPaginas, setTotalPaginas] = useState(0);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [corporateName,setCorporateName] = useState("")
    const [cnpj,setCnpj] = useState("")
    const [loading, setLoading] = useState(true);
    // Incrementado a cada "Pesquisar" para refazer a busca mesmo se já estiver na página 1.
    const [buscaVersao, setBuscaVersao] = useState(0);

    const [confirmOpen,setConfirmOpen] = useState(false);
    const [leadExcluir,setLeadExcluir] = useState(null);

    useEffect(() => {
        getLeads();
    }, [page, buscaVersao]);

    const getLeads = async() => {
        try {
            setLoading(true)

            let result = await api.get("leads", {
                params: {
                    page,
                    pageSize: POR_PAGINA,
                    corporate_name: corporateName || undefined,
                    cnpj: cnpj.replace(/\D/g, "") ? cnpj : undefined,
                }
            });
            const porPagina = result.data.per_page || POR_PAGINA;
            // Math.ceil: com 26 registros e 25 por página são 2 páginas (Math.round dava 1).
            setTotalPaginas(Math.ceil(result.data.total / porPagina));
            setTotalRegistros(result.data.total);
            setRows(result.data.data);
        } catch(exception) {
            toast.error(exception.message);
        } finally {
            setLoading(false)
        }
    }

    const pesquisar = (evt) => {
        if (evt) evt.preventDefault();
        setPage(1);
        setBuscaVersao((v) => v + 1);
    };

    const limpar = () => {
        setCnpj("");
        setCorporateName("");
        setPage(1);
        setBuscaVersao((v) => v + 1);
    };

    function handlePage(evt, value) {
        setPage(value);
    }

    const handleDeleteClick = () => {
        api.delete(`lead/${leadExcluir.id}`).then(() => {
            getLeads()
            toast.success("Lead excluído");
        }).catch(() => {
            toast.error("Não foi possível excluir o lead");
        })
    };

    const exportLeads = async () => {
        setLoading(true)
        try {
            await baixarArquivo("lead-export", "leads.xlsx");
        } catch (erro) {
            toast.error(erro.message || "Não foi possível exportar os leads");
        } finally {
            setLoading(false)
        }
    }

    const temFiltro = Boolean(corporateName || cnpj.replace(/\D/g, ""));

    return (
        <Container maxWidth="lg">
            <PageHeader
                titulo="Leads"
                acoes={
                    <>
                        {pode("importar") && (
                            <Button variant="outlined" component={Link} to="/leads/importacao">
                                Importar
                            </Button>
                        )}
                        {pode("exportar") && (
                            <Button variant="outlined" onClick={exportLeads}>
                                Exportar
                            </Button>
                        )}
                        {pode("editar_leads") && (
                            <Button variant="contained" color="primary" startIcon={<AddIcon />} component={Link} to="/leads/novo">
                                Novo lead
                            </Button>
                        )}
                    </>
                }
            />

            <FilterBar
                onPesquisar={pesquisar}
                onLimpar={limpar}
                ativos={[
                    cnpj.replace(/\D/g, "") && { rotulo: `CNPJ: ${cnpj}`, remover: () => { setCnpj(""); setPage(1); setBuscaVersao((v) => v + 1); } },
                    corporateName && { rotulo: `Razão social: ${corporateName}`, remover: () => { setCorporateName(""); setPage(1); setBuscaVersao((v) => v + 1); } },
                ].filter(Boolean)}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={5} md={4}>
                        <InputMask mask="99.999.999/9999-99" value={cnpj} onChange={(evt) => setCnpj(evt.target.value)}>
                            {(inputProps) => <TextField {...inputProps} label="CNPJ" fullWidth />}
                        </InputMask>
                    </Grid>
                    <Grid item xs={12} sm={7} md={8}>
                        <TextField
                            id="corporate_name"
                            label="Razão social"
                            value={corporateName}
                            onChange={evt => setCorporateName(evt.target.value)}
                            fullWidth />
                    </Grid>
                </Grid>
            </FilterBar>

            <div style={{ height: 4 }}>{loading && <LinearProgress />}</div>

            <Paper variant="outlined" style={{ overflowX: "auto" }}>
                <Table aria-label="Lista de leads">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Razão social</StyledTableCell>
                            <StyledTableCell>CNPJ</StyledTableCell>
                            <StyledTableCell>CNAE</StyledTableCell>
                            <StyledTableCell align="right">Ações</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!loading && rows.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={4} align="center" style={{ padding: 40, color: "#56604F" }}>
                                    Nenhum lead encontrado{temFiltro ? " com esses filtros." : "."}
                                    {temFiltro && <> <Button size="small" onClick={limpar}>Limpar filtros</Button></>}
                                </TableCell>
                            </TableRow>
                        )}
                        {rows.map((row, key) => (
                        <StyledTableRow
                            key={row.id}
                            id={"lead-" + key}
                            hover
                            style={{ cursor: "pointer" }}
                            onClick={() => history.push("/leads/" + row.id + "/edit")}
                        >
                            <StyledTableCell>{row.corporate_name}</StyledTableCell>
                            <StyledTableCell style={{ whiteSpace: "nowrap" }}>{formatarCnpj(row.cnpj)}</StyledTableCell>
                            <StyledTableCell>{row.cnae}</StyledTableCell>
                            <StyledTableCell align="right" style={{ whiteSpace: "nowrap" }} onClick={(e) => e.stopPropagation()}>
                                <Tooltip title="Abrir lead">
                                    <IconButton size="small" component={Link} to={"/leads/" + row.id + "/edit"} aria-label={`Abrir ${row.corporate_name}`}>
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                {pode("excluir") && (
                                    <Tooltip title="Excluir lead">
                                        <IconButton
                                            size="small"
                                            aria-label={`Excluir ${row.corporate_name}`}
                                            onClick={() => {
                                                setLeadExcluir(row)
                                                setConfirmOpen(true)
                                            }}
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </StyledTableCell>
                        </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>

            {totalRegistros > 0 && (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center", justifyContent: "space-between", padding: "12px 0" }}>
                    <span style={{ fontSize: 13, color: "#56604F" }}>
                        {(page - 1) * POR_PAGINA + 1}–{Math.min(page * POR_PAGINA, totalRegistros)} de {totalRegistros}
                    </span>
                    <Pagination count={totalPaginas} page={page} onChange={handlePage} color="primary" />
                </div>
            )}

            <ConfirmDialog
                title="Excluir lead?"
                open={confirmOpen}
                setOpen={setConfirmOpen}
                onConfirm={handleDeleteClick}
            >
                {leadExcluir ? <><b>{leadExcluir.corporate_name}</b> será excluído. Esta ação não pode ser desfeita.</> : null}
            </ConfirmDialog>
        </Container>
    )
}
